// eslint-disable-next-line import/prefer-default-export
export const PAYMENT_METHODS = {
  DOMUSO: 'DOMUSO',
  FORTRESS: 'FORTRESS',
  PAYLEASE: 'PAYLEASE',
};
